import { Box, Grid } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import { InternalNoteCard } from "./InternalNoteCard";
import { InvoiceDetailsCard } from "./InvoiceDetailsCard";
import { InvoiceItemsCard } from "./InvoiceItemsCard";
import { NoteOnInvoiceCard } from "./NoteOnInvoiceCard";

export const InvoiceDetails = observer(function InvoiceDetails() {
  return (
    <React.Fragment>
      <InvoiceDetailsCard />
      <InvoiceItemsCard />
      <Box mt="6">
        <Grid
          gap="4"
          templateColumns={{
            base: "1fr",
            md: "0.5r 0.5r",
          }}
        >
          <NoteOnInvoiceCard />
          <InternalNoteCard />
        </Grid>
      </Box>
    </React.Fragment>
  );
});
